import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { AppStateService } from './app-state.service';
import { environment } from './../../environments/environment';
import { UsersApi } from '../sdk/services/custom/Users';
import { BehaviorSubject, Observable, bindNodeCallback, of } from 'rxjs';
import { PreloaderService } from './preloader.service';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { SharedLoginLogComponent } from 'shared/components/shared-login-log/shared-login-log.component';
import { jwtDecode } from 'jwt-decode';
const createAuth0Client = require('@auth0/auth0-spa-js').default;

@Injectable()
export class AuthService {

   private auth0: any;
    roleClaimPath = environment.auth.ROLES_CLAIM_PATH;
    // Track whether or not to renew token
    private _authFlag = 'isLoggedIn';
    errorMessage = new BehaviorSubject<string>('');
    errorMessage$ = this.errorMessage.asObservable();
    userRolesAndPermissions = {};
    // Authentication navigation
    onAuthSuccessUrl = '/';
    onAuthFailureUrl = '/login';
    logoutUrl = environment.auth.LOGOUT_URL;
    loggedInUserRoles = [];
    loggedInUserPermissions = [];
    sharedDialogRef;
    appStateData: any;
    refreshSubscription: any;
    expiresAt: number;
    appName='';
    private tokenPromise: Promise<string> | null = null;
    constructor(
        private router: Router,
        private _location: Location,
        private _userApi: UsersApi,
        private _appState: AppStateService,
        private _cookieService: CookieService,
        private _preloaderService: PreloaderService,
        private _dialog: MatDialog
    ) {
        
    }
    async initAuth(appName) {
        this.appName = appName;
        this.auth0 = await createAuth0Client({
            domain: environment.auth.CLIENT_DOMAIN,
            client_id: environment.auth.CLIENT_ID,
            audience: environment.auth.AUDIENCE,
            cacheLocation: 'localstorage',
            useRefreshTokens: true,
            redirect_uri: environment.auth.REDIRECT,
            scope: 'openid email profile offline_access ' + appName
        });
    }

    async login(appName, loginVia) {   
        if (!this.auth0) {
            await this.initAuth(appName);
        }
        await this.auth0.loginWithRedirect({
            connection: loginVia == 'email' ? '' : 'sms'
        });

    }

    openSharedLoginLogPopup(user = null) {
        if (this.sharedDialogRef) return;
        this.sharedDialogRef = this._dialog.open(SharedLoginLogComponent, {
            width: '60%',
            data: {},
            panelClass: 'job-message-email-popup-dialog-container',
            disableClose: true
        });

        this.sharedDialogRef.afterClosed().subscribe(result => {
            if (result && result !== undefined) {
                console.log(result)
                if (user) {
                    this.successRedirect(user);
                }
            }
        });
    }

    updateUserRoles(){
        const token = this.getAccessToken()
        const decoded = jwtDecode(token);
        this.loggedInUserRoles = decoded[this.roleClaimPath];
        this.loggedInUserPermissions = decoded["permissions"];
        if(this.loggedInUserRoles && this.loggedInUserRoles.length > 0){
            this._appState.setUserRoles(this.loggedInUserRoles);
        }
    }

    successRedirect(user) {
        const redirectUrl = localStorage.getItem("redirectUrl");
        if (redirectUrl) {
          this.onAuthSuccessUrl = redirectUrl;
        }
        const queryParam = user.userinfo['queryParam'] ? user.userinfo['queryParam'] : {};
        if (queryParam && Object.keys(queryParam).length) {
            this.router.navigate([this.onAuthSuccessUrl], { queryParams: queryParam });
        } else {
            this.router.navigateByUrl(this.onAuthSuccessUrl);
        }
    }

   async handleLoginCallback(appName) {
       if (!this.auth0) {
           await this.initAuth(appName);
       }
       
       try {
           await this.auth0.handleRedirectCallback();
           const authResult = await this.getAuthContext();
           if (authResult && authResult.accessToken) {
               this._setAuth(authResult);
               this._userApi.getUserData({
                   email: authResult["idTokenPayload"].email,
                   app: appName
               }).subscribe(
                   user => {
                       if (user && user.userinfo && !user.userinfo.isActive) {
                           this.errorMessage.next('User doesn\'t exist');
                           this.router.navigate([this.onAuthFailureUrl]);
                       } else {
                           if (!this.appStateData) {
                               this.appStateData = {}
                           }
                           this.loggedInUserRoles = authResult["idTokenPayload"][this.roleClaimPath];
                           this.loggedInUserPermissions = authResult["permissions"];
                           this._cookieService.set('$LoopBackSDK$user', JSON.stringify(user.userinfo));
                           this._cookieService.set('$LoopBackSDK$userId', user.userinfo.id);
                           this.appStateData.user = user.userinfo;
                           localStorage.setItem('appData', JSON.stringify(this.appStateData));
                           localStorage.setItem('accessType', user.userinfo['accessType']);
                           localStorage.setItem('userTypeSlug', user.userinfo.userType.slug);
                           localStorage.setItem('manageUser', (user.userinfo.manageUser) || false);
                           const docCategory = user.userinfo && user.userinfo.docCategory ? user.userinfo.docCategory : [];
                           localStorage.setItem('filePermissions', JSON.stringify(docCategory));
                           this.setAppState({
                               appData: this.appStateData,
                               accessType: user.userinfo['accessType'],
                               workerType: user.userinfo.workers && user.userinfo.workers[0].Worker_Type__c ? user.userinfo.workers[0].Worker_Type__c : '',
                               workerTypeSub: user.userinfo.workers && user.userinfo.workers[0].Worker_Type_Sub__c ? user.userinfo.workers[0].Worker_Type_Sub__c : '',
                               userTypeSlug: user.userinfo.userType.slug,
                               filePermissions: docCategory,
                               manageUser: user.userinfo.manageUser || false
                           });

                           this.onAuthSuccessUrl = user.userinfo['redirectUrl'];
                           if (this.appStateData && this.appStateData.user && this.appStateData.user.SharedLogin) {
                               this.openSharedLoginLogPopup(user);
                           } else {
                               this.successRedirect(user);
                           }

                           let firstTimeLogin = this.appStateData['user'] && this.appStateData['user']['lastLogin'] && this.appStateData['user']['lastLogin'].length ? false : true;
                           let worker_Type = this.appStateData['user'] && this.appStateData['user']['workers'] && this.appStateData['user']['workers'].length ? this.appStateData['user']['workers'][0]['Worker_Type_Sub__c'] : '';
                           let access_Type = this.appStateData['user'] && this.appStateData['user']['accessType'] && this.appStateData['user']['accessType'].length ? this.appStateData['user']['accessType'] : '';
                           let filterObj = JSON.parse(localStorage.getItem('filterObj'));
                           let accFilter = filterObj['accountCommunities'] && filterObj['accountCommunities'].length ? true : false;

                           if (firstTimeLogin == true && worker_Type == 'VMSA' && accFilter == false && access_Type == 'vendor') {
                               this.router.navigate(['/vms/vms-billing-manager'], { queryParams: { activeId: 'accountProfile' } });
                           }
                       }
                   },
                   error => {
                       this.router.navigate([this.onAuthFailureUrl]);
                   }
               )

           } else {
               this.router.navigate([this.onAuthFailureUrl], { queryParams: { error: window.location.hash } });
           }
       } catch (err) {
           console.log('handleRedirectCallback error', err);
           const errStr = err && (err.error || err.message) ? (err.error || err.message) : String(err);
           // If access was denied or consent required, navigate to failure page and stop further processing
           if (
               errStr === 'access_denied' ||
               errStr === 'consent_required' ||
               (typeof errStr === 'string' && errStr.indexOf('access_denied') !== -1)
           ) {
               this.errorMessage.next('Access denied!!');
               this.router.navigate([this.onAuthFailureUrl]);
               return;
           }
           // For other errors, navigate to failure with error info
           this.router.navigate([this.onAuthFailureUrl], { queryParams: { error: errStr } });
           return;
       }
   }

    getTokenExpiryFromStorage() {
        const key = Object.keys(localStorage).find(k =>
            k.startsWith('@@auth0spajs@@')
        );

        if (!key) return null;
        const item = JSON.parse(localStorage.getItem(key));
        return item;
    }

    setAppState(obj) {
        if (obj && obj.appData && obj.accessType) {
            // console.log(obj)
            // console.log('setAppstate===> found')
            this._appState.setAppState(obj.appData);
            this._appState.setAccessType(obj.accessType);
            this._appState.setWorkerType(obj.workerType);
            this._appState.setUserTypeSlug(obj.userTypeSlug);
            this._appState.setFileManagerPermissions(obj.filePermissions);
            this._appState.setmanageUser(obj.manageUser);
            const token =  this.getAccessToken();
            if (token) {
                const decoded = jwtDecode(token);
                this.loggedInUserRoles = decoded[this.roleClaimPath];
                this.loggedInUserPermissions = decoded["permissions"];
                if (this.loggedInUserRoles && this.loggedInUserRoles.length > 0) {
                    this._appState.setUserRoles(this.loggedInUserRoles);
                }
            }

            if (!this._appState.getSelectedAccount()) {
                // Need to remove the hardcoded MagicLink Account Id once we do not have any dependency on the same
                if ((obj.accessType === 'internal' && this._location.path().indexOf('pms') !== -1) || (obj.accessType === 'vendor')) {
                    this._appState.setSelectedAccount(obj.appData.user['AccountId']);
                }
                if (obj.accessType === 'partner') {
                    this._appState.setSelectedAccount(obj.appData.user['AccountId']);
                }
            } else {
                localStorage.clear();
                this._cookieService.deleteAll();
                this.router.navigate(['/login'])
            }
        } else {
            localStorage.clear();
            this._cookieService.deleteAll();
            this.router.navigate(['/login'])
        }

    }
    private _setAuth(authResult) {
        localStorage.setItem(this._authFlag, JSON.stringify(true));
    }

    get authenticated(): boolean {
        if (JSON.parse(localStorage.getItem('appData')) && JSON.parse(localStorage.getItem('appData'))['user'] &&
            JSON.parse(localStorage.getItem('appData'))['user']['SharedLogin']) {
            this.openSharedLoginLogPopup();
        }
        return JSON.parse(localStorage.getItem(this._authFlag)) ? JSON.parse(localStorage.getItem(this._authFlag)) : false;
    }

    get isRememberMe(): boolean {
        return JSON.parse(localStorage.getItem('rememberMe'));
    }

    async logout() {
        // Set authentication status flag in local storage to false
        localStorage.clear();
        sessionStorage.clear();
        // This does a refresh and redirects back to homepage
        // Make sure you have the logout URL in your Auth0
        // Dashboard Application settings in Allowed Logout URLs   
        if (!this.auth0) {
            await this.initAuth(this.appName);
        }     
        await this.auth0.logout({
            returnTo: window.location.origin
        });
    }

    resolve() {
        const userObj = JSON.parse(localStorage.getItem('appData')).user;
        if (!this._appState.getAppState().observers.length) {
            this._appState.setAppState(JSON.parse(localStorage.getItem('appData')));
        }
        // set account id
        if (!this._appState.getSelectedAccount()) {
            // Need to remove the hardcoded MagicLink Account Id once we do not have any dependency on the same
            if (userObj['accessType'] === 'internal' && this._location.path().indexOf('pms') !== -1) {
                this._appState.setSelectedAccount(userObj['AccountId']);
            }
            if (userObj['accessType'] === 'partner') {
                this._appState.setSelectedAccount(userObj['AccountId']);
            }
        }
        // set access type
        if (!this._appState.getAccessType()) {
            this._appState.setAccessType(userObj['accessType']);
        }
        if (!this._appState.getWorkerType()) {
            this._appState.setWorkerType(userObj['workers'] && userObj['workers'].length ? userObj['workers'][0].Worker_Type__c : '');
        }
        // set home url
        if (!this._appState.getHomeUrl()) {
            this._appState.setHomeUrl(userObj['redirectUrl']);
        }
        // set adminAccessPermission
        if (this._appState.getAdminAccessPermission() === undefined) {
            if (sessionStorage.getItem('adminAccessPermission') !== null) {
                const adminAccessPermission = sessionStorage.getItem('adminAccessPermission') === 'true'
                    ? true : false;
                this._appState.setAdminAccessPermission(adminAccessPermission);
            } else {
                this._userApi.adminAccessPermission().subscribe(
                    res => {
                        let adminAccessPermission = false;
                        if (res) {
                            adminAccessPermission = true;
                            sessionStorage.setItem('adminAccessPermission', 'true');
                        }
                        this._appState.setAdminAccessPermission(adminAccessPermission);
                    },
                    err => {
                        console.log(err);
                    }
                );
            }

        }
        if (!this._appState.getAccessType()) {
            this._appState.setmanageUser(userObj['manageUser']);
        }
        return userObj;
    }
    async isAuthenticated() {
        const isAuthenticated = await this.auth0.isAuthenticated();
        return isAuthenticated;
    }

    async renewTokens() {
        if (!this.auth0) {
            await this.initAuth(this.appName);
        }

        // 1. If a request is ALREADY in progress, return that same promise
        if (this.tokenPromise) {
            return this.tokenPromise;
        }

        // 2. Assign the Promise IMMEDIATELY to the variable
        // This 'locks' the function so other calls wait for this specific execution
        this.tokenPromise = await this.auth0.getTokenSilently()
            .then(token => {
                this.tokenPromise = null; // Clear lock on success
                return token;
            })
            .catch(err => {
                this.tokenPromise = null; // Clear lock on error so we can try again
                console.log("===========e==============",err.error)
                if (
                    err.error === 'login_required' ||
                    err.error === 'consent_required' ||
                    err.error === 'access_denied'
                ) {
                     this.logout();

                    return null; // IMPORTANT: don't throw
                }
                throw err;
            });

        return this.tokenPromise;
    }

    getAccessToken() {
        const res = this.getTokenExpiryFromStorage();       
        return res && res.body && res.body.access_token ? res.body.access_token : null;
    }

    

    getAccessTokenOnce(): Promise<string> {
        if (!this.tokenPromise) {
            this.tokenPromise = this.auth0.getTokenSilently();
        }
        return this.tokenPromise;
    }


    async getAuthContext() {
        const accessToken = this.getAccessToken();
        const idTokenClaims = await this.auth0.getIdTokenClaims();
        const decodedAccessToken = jwtDecode(accessToken);
        return {
            accessToken: accessToken,
            expiresAt: idTokenClaims.exp * 1000,
            idTokenPayload: idTokenClaims,
            permissions: decodedAccessToken['permissions'] || []
        };
    }

   
}
